import { Injectable } from '@angular/core';
import { User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable } from 'rxjs';
import { filter, map, pluck, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UigUserRolesService {
    roles: String[];

    constructor(private userAccountFacade: UserAccountFacade) {
    }

    hasRoleOrAuthority(role?: string, authority?: string): Observable<boolean> {
      return this.userAccountFacade
            .get()
            .pipe(
                filter((user: User) => user && Object.keys(user).length > 0),
                tap((user) => {
                    this.roles = user.roles;
                }),
                pluck('authorities'),
                map((authorities: string[]) => {
                    const hasRole =
                        (authority && authorities && Array.isArray(authorities) && authorities.includes(authority))
                        || (role && this.roles && this.roles.includes(role));

                    if (hasRole) {
                        return true;
                    }
                    return false;
                })
            );
    }

}